export const isDatumDraft = (datum: any): boolean => {
    if (!datum) {
        return false;
    }

    const statusCandidates = [
        datum.content_status,
        datum.contentStatus,
        datum.status,
        datum.datum_status,
        datum.state,
    ];

    const hasDraftStatus = statusCandidates.some((value) => {
        if (typeof value !== 'string') {
            return false;
        }
        return value.trim().toLowerCase() === 'draft';
    });

    if (hasDraftStatus) {
        return true;
    }

    const booleanCandidates = [
        datum.is_draft,
        datum.isDraft,
        datum.draft,
    ];

    return booleanCandidates.some((value) => value === true || value === 1 || value === '1');
};
